import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

import { NavItem } from '../Header/MegaNavigation/MegaNavigation.types';
import SidePanel from './SidePanel';
import { NestedAccordion } from './NestedAccordion';
import { usePageData } from 'lib/page-data/PageDataContext';
import { HelpArticleData } from 'model/HelpArticle';
import { SitecoreItem } from 'model/Common';
import { normalizeGuid } from 'lib/utils/normalizeGuid';
import { flattenSingleLinkSubcategories } from 'lib/utils/flattenSingleLinkSubcategories';

type Fields = {
  items: Array<NavItem>;
  tabLabel: Field<string>;
  showForPlatform: SitecoreItem[];
};

type SideNavigationProps = ComponentProps & {
  fields: Fields;
};

const SideNavigation = (props: SideNavigationProps): JSX.Element => {
  const helpArticleData: HelpArticleData = (usePageData('helpArticle') ?? {}) as HelpArticleData;
  const pagePlatformIds =
    helpArticleData?.helpPlatform?.targetItems?.map((item) => normalizeGuid(item?.id) ?? '') ?? [];
  const sideNavPlatformIds =
    props.fields?.showForPlatform?.map((item) => normalizeGuid(item?.id) ?? '') ?? [];

  const hasPlatformIntersection = (() => {
    // only compare if page has platforms defined
    if (!pagePlatformIds.length) {
      return true;
    }

    const sideSet = new Set(sideNavPlatformIds);
    return pagePlatformIds.some((id) => sideSet.has(id));
  })();

  if (!props.fields?.items || props.fields.items.length === 0) {
    return <></>;
  }

  if (!hasPlatformIntersection) {
    return <></>;
  }

  const flattenedItems = flattenSingleLinkSubcategories(props.fields.items);

  return (
    <>
      <SidePanel tabLabel={props.fields.tabLabel}>
        <NestedAccordion data={flattenedItems}></NestedAccordion>
      </SidePanel>
    </>
  );
};

export default withDatasourceCheck()<SideNavigationProps>(SideNavigation);
